<style lang="less" rel="stylesheet/less" scope>
  .wrapper {
    height: 90px;
    background: url("./../../assets/homepage/headbg.png") right repeat-y;
    background-color: #00a0e8;
    .container {
      max-width: 1200px;
      min-width: 1000px;
      padding: 0 25px;
      height: 90px;
      line-height: 90px;
      margin: 0 auto;
      color: #ffffff;
      .left {
        display: inline-block;
        h3 {
          display: inline-block;
          padding-right: 15px;
          font-size: 20px;
          font-weight: 600;
        }
        img {
          vertical-align: middle;
        }
      }
      .right {
        font-weight: 600;
        font-size: 14px;
        a{
          text-decoration: none;
          i {
            padding-right:6px;
          }
          &:active, &:hover, &:visited, &:link {
            color: inherit;
          }
          &.right-info {
            padding-right: 14px;
            &:last-child {
              padding: 0;
            }
          }
        }
        span {
          padding-right: 14px;
        }
      }
    }
    section {
      position: relative;
      overflow: hidden;
      background-size:contain;
      background: url("./../../assets/homepage/bg.jpg") center no-repeat;
      background-size: cover;
      .animation-cloud(@top,@left,@width,@heigth,@url,@keyframes-run,@time) {
        position: absolute;
        top: @top;
        left: @left;
        width: @width;
        height: @heigth;
        background: url(@url) center no-repeat;
        animation: @keyframes-run @time linear infinite alternate;
        -moz-animation: @keyframes-run @time linear infinite alternate;
        -webkit-animation: @keyframes-run @time linear infinite alternate;
        -o-animation: @keyframes-run @time linear infinite alternate;
      }
      .cloud-wrapper-one {
        .animation-cloud(400px,0,650px,360px,"./../../assets/homepage/cloud1.png",cloudleft,65s);
      }
      .cloud-wrapper-two {
        .animation-cloud(100px,600px,580px,300px,"./../../assets/homepage/cloud2.png",cloudright,65s);
      }
      @keyframes cloudleft {
        from {
          left: 0;
        }
        to {
          left: 100%;
        }
      }
      @keyframes cloudright {
        from {
          left: 600px;
        }
        to {
          left: 100%;
        }
      }
      .section-wrapper {
        width: 1260px;
        margin: 0 auto;
        .main-wrapper {
          position: relative;
          .app-items-wrapper {
            margin: 150px auto 0;
            .app-items {
              float: left;
              width: 180px;
              height: 202px;
              .app{
                display: block;
                text-align: center;
                cursor: pointer;
                &:hover {
                  img {
                    transform:scale(1.1);
                    -webkit-transform:scale(1.1);
                    -moz-transform:scale(1.1);
                    -o-transform:scale(1.1);
                    -ms-transform:scale(1.1);
                    opacity: .8;
                    box-shadow: 0 2px 16px #bec2cd, 0 0 1px #bec2cd, 0 0 1px #bec2cd;
                  }
                }
              }
              img {
                display: inline-block;
                width: 120px;
                height: 120px;
                border-radius: 20px;
                transition:All .3s ease-in-out;
                -webkit-transition:All .3s ease-in-out;
                -moz-transition:All .3s ease-in-out;
                -o-transition:All .3s ease-in-out;
              }
              h4 {
                margin: 18px 0 30px;
                font-family: "Microsoft Yahei";
                font-weight: bold;
                font-size: 20px;
                color: #555555;
                text-align: center;
                span {
                  display: inline-block;
                  padding: 0 10px;
                }
              }
            }
          }
        }
      }
    }
    .change-email-wrapper {
      height: 150px;
      background-color: #FFFFFF;
      .header {
        background-color: #00A1E9;
        p {
          display: inline-block;
        }
        i {
          padding-right: 5px;
          color: #FFFFFF;
        }
        .top-nav-header .top-nav-info span,a {
          color: #FFFFFF;
        }
      }
    }
  }

  @media screen and (max-width: 1260px) {
    .wrapper {
      .header-wrapper .container {
        width: 940px;
      }
      section {
        .section-wrapper {
          width: 960px;
          .main-wrapper {
            .app-items-wrapper {
              width: 320px;
              .app-items {
                width: 160px;
                height: 177px;
                img {
                  width: 100px;
                  height: 100px;
                  border-radius: 12px;
                }
                h4 {
                  margin-top: 16px;
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 900px) {
    .wrapper {
      .header-wrapper .header .left h3 {
        font-size: 16px;
      }
    }
  }
</style>
<template>
  <div class="wrapper" v-if="userInfo.loginDate && userInfo.email&&appList.length > 1">
    <div class="container" ref="header">
      <div class="left">
        <h3>{{api.PLATFORM_NAME?api.PLATFORM_NAME:'大装备一体化管理服务云平台'}}</h3>
        <img src="./../../assets/login/log.png" alt="">
      </div>
      <div class="right pull-right">
        欢迎您：<span v-text="userInfo.name"></span>
        <router-link :to="{name: 'index'}" class="right-info"><i class="el-icon-fa-user-circle"></i>用户中心 </router-link>
        <a href="javascript:;" class="right-info" v-if="$store.getters.userInfo.simulate == 1" @click="cancel"><i class="el-icon-fa-sign-out"></i>注销</a>
        <a href="javascript:;" class="right-info" @click="logout"><i class="el-icon-fa-power-off"></i>退出</a>
      </div>
    </div>
    <section class="clearfix" v-bind:style="{'height': (windowHeight - 90) + 'px'}">
      <div class="cloud-wrapper-one"></div>
      <div class="cloud-wrapper-two"></div>
      <div class="section-wrapper">
        <div class="main-wrapper clearfix">
          <div class="app-items-wrapper clearfix" :style="{'width': appWidth}">
            <div v-for="items in appList" class="app-items" v-if="items.id!=3">
              <a :href="items.url?items.url:''" class="app">
                <ly-default-image :src="items.img" :id="items.id"></ly-default-image>
                <h4 class="item-title">
                  <span>{{items.name}}</span>
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ly-customer-board></ly-customer-board>
  </div>
</template>
<script type='text/ecmascript-6'>
  import defaultImage from '@/components/default-image/index'
  import customerBoard from '@/components/customer-board'
  import store from '@/store'
  import logOutMixin from '@/components/layout/logout-mixin'
  import { logout } from '@/utils/logout'
  import { mapState } from 'vuex'

  export default {
    components: {
      defaultImage,
      customerBoard
    },
    mixins: [logOutMixin],
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (to.query.cancel) {
          next({ name: 'users' });
          return false;
        }
        store.dispatch('GetInfo').then((res) => {
          if (res.loginDate && res.email) {
            vm.getAppList().then(app => {
              if (app.length == 0) {
                localStorage.IPORTAL = true;
                next('/index');
              } else if (app.length == 1) {
                if (app[0].url == null) {
                  next('/index');
                } else {
                  localStorage.OA = 'TRUE';
                  window.location.href = app[0].url + "?onlyApp";
                }
              } else {
                next('/platform');
              }
            });
            vm.userInfo = store.getters.userInfo;
          } else {
            vm.$message({
              message: '为了您的信息安全,请补全用户信息',
              type: 'warning',
              duration: 2000,
              showClose: false,
              onClose: function () {
                next('/change_email');
              }
            })
          }
        })
      });
    },
    data: () => ({
      userInfo: {
        name: ''
      },
      appList: [],
      windowHeight:  document.documentElement.clientHeight,
    }),
    computed: {
      ...mapState({api: state => state.api}),
      iportalGlobalURL() {
        return this.api.BASE_API;
      },
      appWidth() {
        return this.setAppWidth(this.appList.length) + 'px';
      }
    },
    methods: {
      getAppList() {
        return new Promise((resolve, reject) => {
          store.dispatch('GetPlatFormApp').then((res) => {
            let appList = res;
            if (appList != null) {
              for (let i in appList) {
                var id = appList[i].id;
                if (id != 3) {
                  if (id == 10) {
                    var token = store.getters.token;
                    appList[i].url += "?access_token=" + token.access_token + "&token_type=" + token.token_type + "&expires_in=" + token.expires_in;
                  }
                  this.appList.push(appList[i]);
                }
              }
              resolve(this.appList);
            } else {
              this.$confirm('您还未拥有权限进入应用系统', '温馨提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'warning'
              }).then(() => {
                logout();
              }).catch(() => {
                logout();
              });
              reject();
            }
          })
        })
      },
      setAppWidth(len) {
        if (window.innerWidth > 1260) {
          if (len > 5) {
            if (len%2 == 0) {
              return len/2*180;
            } else {
              return (len+1)/2*180;
            }
          } else {
            return len*180;
          }
        } else {
          if (len > 5) {
            if (len%2 == 0) {
              return len/2*160;
            } else {
              return (len+1)/2*160;
            }
          } else {
            return len*160;
          }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/platform/platform.vue